import { render, staticRenderFns } from "./BottomSheetRefuseNotifications.vue?vue&type=template&id=8c8ad494&scoped=true&"
import script from "./BottomSheetRefuseNotifications.vue?vue&type=script&lang=js&"
export * from "./BottomSheetRefuseNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetRefuseNotifications.vue?vue&type=style&index=0&id=8c8ad494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8ad494",
  null
  
)

export default component.exports